export default {
    namespaced: true,
    state: {
        isProductRoot: false,
    },
    getters: {
        isProductRoot(state) {
            return state.isProductRoot;
        },
    },
    actions: {
        setIsProductRoot({commit}, payload) {
            commit('storeIsProductRoot', payload);
        },
    },
    mutations: {
        storeIsProductRoot(state, payload) {
            state.isProductRoot = payload;
        },
    },
}